var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInboxSelectConversation = function SvgInboxSelectConversation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 231,
      height: 231,
      viewBox: "0 0 231 231",
      fill: "none",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 24.5,
      y: 47.5,
      width: 157,
      height: 64,
      rx: 16,
      fill: "#F2F9F9"
    })), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("circle", {
      cx: 48.5,
      cy: 71.5,
      r: 16,
      fill: "#A7D2D6"
    })), _ref4 || (_ref4 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 72.5,
      y: 55.5,
      width: 52,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref5 || (_ref5 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 157.5,
      y: 55.5,
      width: 16,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref6 || (_ref6 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 165.5,
      y: 95.5,
      width: 8,
      height: 8,
      rx: 4,
      fill: "#A7D2D6"
    })), _ref7 || (_ref7 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 72.5,
      y: 73.5,
      width: 75,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref8 || (_ref8 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 72.5,
      y: 85.5,
      width: 75,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref9 || (_ref9 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 72.5,
      y: 97.5,
      width: 30,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref10 || (_ref10 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 49.5,
      y: 119.5,
      width: 157,
      height: 64,
      rx: 16,
      fill: "#F2F9F9"
    })), _ref11 || (_ref11 =
    /*#__PURE__*/
    React.createElement("circle", {
      cx: 73.5,
      cy: 143.5,
      r: 16,
      fill: "#A7D2D6"
    })), _ref12 || (_ref12 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 97.5,
      y: 127.5,
      width: 52,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref13 || (_ref13 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 182.5,
      y: 127.5,
      width: 16,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref14 || (_ref14 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 190.5,
      y: 167.5,
      width: 8,
      height: 8,
      rx: 4,
      fill: "#A7D2D6"
    })), _ref15 || (_ref15 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 97.5,
      y: 145.5,
      width: 75,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref16 || (_ref16 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 97.5,
      y: 157.5,
      width: 75,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })), _ref17 || (_ref17 =
    /*#__PURE__*/
    React.createElement("rect", {
      x: 97.5,
      y: 169.5,
      width: 30,
      height: 6,
      rx: 3,
      fill: "#A7D2D6"
    })))
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgInboxSelectConversation, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/inbox-select-conversation.840ca2ce.svg";
export { ForwardRef as ReactComponent };